<script>
  import PageError from "#lib/PageError.svelte";
  import HalfHourlyBooking from "#lib/HalfHourlyBooking.svelte";
  import DailyBooking from "#lib/DailyBooking.svelte";
  import SubscriptionBooking from "#lib/SubscriptionBooking.svelte";
  import MainPageContent from "#lib/MainPageContent.svelte";
  import Toaster from '#lib/Toaster.svelte';
  import t from '#lib/i18n.svelte.js';

  // import Footer from "#lib/Footer.svelte";
  import SEO from "#lib/SEO.svelte";
  import { getContext } from "svelte";
  let site_settings = getContext('site_settings');
  let { data } = $props();
</script>

<!-- Currently we fall back to the site description if no description could be extracted from the entry's content. -->
<SEO
  title={`${t('book_now')} | ${data.resource.title}`}
  image={data.resource.images?.[0]?.src}
  type={data.resource.resource_type}
  author={site_settings.name}
/>

{#if data.status !== 200}
  <PageError status={data.status} message={data.message} />
{:else}
  <MainPageContent>
    <!-- {#snippet dynamic_island_row_2()}
    {/snippet} -->
    <!-- NOTE: data.slots is only populated for meeting_room resources (see +page.server.js) —
         other half_hourly resource types (e.g. equipment) are not bookable yet and would
         crash HalfHourlyBooking with undefined slots -->
    {#if data.resource.booking_type === 'half_hourly' && data.slots}
      <HalfHourlyBooking {data} />
    {:else if data.resource.booking_type === 'daily'}
      <DailyBooking {data} />
    {:else if data.resource.booking_type === 'subscription'}
      <SubscriptionBooking {data} />
    {:else}
      Booking type not yet supported
    {/if}
    {#snippet footer()}
      <!-- The footer will add an "uncontrollable" height to the page and add another y-scrollbar -->
      <!-- <Footer /> -->
    {/snippet}
  </MainPageContent>
{/if}

<Toaster />